<template>
  <table v-if="loading" class="table table-borderless table-border table-align col-md-12">
    <thead>
    <tr>
      <th>Placa</th>
      <th>Renavam</th>
      <th>CNPJ</th>
      <th>Quantidade</th>
      <th>Valor total</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="item in 5" :key="item.index">
        <td class="pt-2"><Skeleton animation-duration="1.8s" /></td>
        <td class="pt-2"><Skeleton animation-duration="1.9s"/></td>
        <td class="pt-2"><Skeleton /></td>
        <td class="pt-2"><Skeleton animation-duration="2s"/></td>
        <td class="pt-2"><Skeleton animation-duration="1.5s"/></td>
        <td class="pt-2"><Skeleton col="10" /></td>
      </tr>
    </tbody>
  </table>

  <table v-else class="table table-borderless table-border table-align col-md-12">
    <thead>
      <tr>
        <th>Placa</th>
        <th>Renavam</th>
        <th>CNPJ</th>
        <th>Quantidade</th>
        <th>Valor total</th>
        <th></th>
      </tr>
    </thead>
    <tbody v-if="vehicles.length">
      <tr v-for="vehicle in vehicles" :key="vehicle.id">
        <td>{{ vehicle.plate }}</td>
        <td>{{ vehicle.renavam }}</td>
        <td v-if="vehicle.cnpj">{{ vehicle.cnpj | cnpj }}</td>
        <td v-else> - </td>
        <td>{{ vehicle.count }}</td>
        <td>{{ vehicle.sum | price }}</td>
        <td>
          <router-link :to="link(vehicle.plate)">
            <button  class="btn btn-sm btn-primary mr-2">Detalhes</button>
          </router-link>
        </td>
      </tr>
    </tbody>
    <div v-else class="mt-4">
        Não foi encontrado nenhum veículo
    </div>
  </table>
</template>

<script>
import GetAccount from '../../../mixins/GetAccount.vue'
import Skeleton from '@/components/utils/Skeleton.vue';

export default {
  components: {Skeleton},
  methods: {
    link(plate) {
      const params = [
        '/cm-frotas?',
        'o[]=updated_at',
        'o[]=desc',
        `q[generic]=${plate}`,
        `q[period_type]=${this.periodType || 'occurred_at'}`,
        `q[start_date]=${this.startDate}`,
        `q[end_date]=${this.endDate}`
      ]

      if (this.entityStatusId)
        params.push(`q[entity_status_id]=${this.entityStatusId}`)

      return params.join('&')
    }
  },
  name: 'Vehicles',
  mixins: [GetAccount],
  props: {
    vehicles: { required: true, type: Array },
    loading: { required: true, type: Boolean },
    endDate: { required: true, type: String },
    startDate: { required: true, type: String },
    periodType: String,
    entityStatusId: [String, Number],
  }
}
</script>

<style scoped>

</style>